/**
 * PUT file bytes to an S3 presigned URL from the browser.
 *
 * **CORS:** The S3 bucket must allow your app origin, method PUT, and headers
 * (at least `Content-Type`). If you see a CORS error in DevTools, fix the bucket
 * CORS — it cannot be solved from JS alone. See `core-platform/deployment/s3-community-assets-cors.json`.
 *
 * @param {string} uploadUrl
 * @param {Blob|File} file
 * @param {string} contentType Must match what the backend used when signing (e.g. application/pdf).
 */
export async function putToPresignedUrl(uploadUrl, file, contentType) {
  const ct = String(contentType || file.type || "application/octet-stream").trim();

  const res = await fetch(uploadUrl, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": ct,
    },
    mode: "cors",
    credentials: "omit",
    cache: "no-store",
  });

  if (!res.ok) {
    const detail = await readErrorBody(res);
    throw new Error(
      detail ? `Falha no upload (${res.status}): ${detail}` : `Falha no upload (${res.status})`
    );
  }
}

/**
 * @param {Response} res
 * @returns {Promise<string>}
 */
async function readErrorBody(res) {
  try {
    const text = await res.text();
    return text?.slice(0, 200) || "";
  } catch {
    return "";
  }
}
